import { ESearchResultsActionType } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const setSearchResultsSidebarReady = actionGenerator<ESearchResultsActionType.SidebarReady, boolean>(
  ESearchResultsActionType.SidebarReady,
);
